/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { VideoVisitEndedPayloadSideEffectType } from "./VideoVisitEndedPayloadSideEffectType";

export interface VideoVisitEndedPayload {
  side_effect_type: VideoVisitEndedPayloadSideEffectType;
  conversation_id: string;
}
